import { createClient } from '@supabase/supabase-js';

const PRODUCTION_PROJECT_REF = 'qfhhoivedoavxvpwohsi';

/** Recusa no browser qualquer destino que não seja o Supabase local ou o projeto exclusivo do ReMonta. */
function assertClientTarget(env: ImportMetaEnv): { url: string; anonKey: string } {
  const url = env.VITE_SUPABASE_URL;
  const anonKey = env.VITE_SUPABASE_ANON_KEY;
  if (!url || !anonKey) throw new Error('VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are required');
  const parsed = new URL(url);
  const local = env.VITE_REMONTA_ENV === 'local' && parsed.protocol === 'http:' &&
    ['127.0.0.1', 'localhost'].includes(parsed.hostname) && parsed.port === '54321';
  const production = env.VITE_REMONTA_ENV === 'production' &&
    env.VITE_REMONTA_SUPABASE_PROJECT_REF === PRODUCTION_PROJECT_REF &&
    parsed.protocol === 'https:' && parsed.hostname === `${PRODUCTION_PROJECT_REF}.supabase.co` && !parsed.port;
  if (!local && !production) throw new Error('Destino Supabase do cliente não autorizado para o ReMonta');
  return { url, anonKey };
}

const target = assertClientTarget(import.meta.env);

export const supabase = createClient(target.url, target.anonKey);
